<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Currency
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Currency Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="currencyList"
            class="elevation-1"
            :loading="showListLoading"
            :rows-per-page-items="rowsPerPageItems"
            :total-items="totalRows"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date }}</td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                <v-icon v-if="props.item.status=='ACTIVE'" medium color="green">spellcheck</v-icon>
                <v-icon v-else medium color="red">format_italic</v-icon>
              </td>
              <td>
                <v-icon v-if="props.item.defaultCurrency" medium color="green">spellcheck</v-icon>
                <v-icon v-else medium color="red">format_italic</v-icon>
              </td>
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { currencyService } from "../../services/currency-service";

export default {
  name: "CurrencyList",

  components: {},
  data: () => ({
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Currency Management",
        disabled: true
      },
      {
        text: "Currency",
        disabled: true
      }
    ],
    statusList: [
      { label: "--- Select Status ---", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" }
    ],
    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Code", value: "code" },
      { text: "Description", value: "description" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated  By", value: "updatedBy" },
      { text: "Status", value: "status", sortable: false },
      { text: "Default", value: "default", sortable: false },
      { text: "Action", value: "name", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 25,
      sortBy: "name",
      totalItems: 0
    },
    queryParams: {
      name: "",
      status: ""
    },
    currencyList: [],
    totalRows: 0,
    sortedBy: "name,desc"
  }),
  watch: {
    pagination: {
      handler() {
        this.getCurrencyList();
      },
      deep: true
    }
  },
  created() {
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "currencies", query: this.queryParams });
      this.getCurrencyList();
    },

    getCurrencyList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      currencyService
        .getCurrencyList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.currencyList = res.data.currencyList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    onRegister() {
      this.$router.push("/currency/new");
    },

    onEdit(currrency) {
      // go to details page
      this.$router.push("/currency/" + currrency.id);
    }
  }
};
</script>

<style scoped>
</style>